var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg146(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 11.9798C11.809 11.9798 11.1466 11.7055 10.6583 11.2171C10.1699 10.7287 9.89551 10.0663 9.89551 9.37565C9.89551 8.68498 10.1699 8.0226 10.6583 7.53423C11.1466 7.04585 11.809 6.77148 12.4997 6.77148C13.1903 6.77148 13.8527 7.04585 14.3411 7.53423C14.8295 8.0226 15.1038 8.68498 15.1038 9.37565C15.1038 9.71763 15.0365 10.0563 14.9056 10.3722C14.7747 10.6882 14.5829 10.9753 14.3411 11.2171C14.0993 11.4589 13.8122 11.6507 13.4962 11.7816C13.1803 11.9125 12.8417 11.9798 12.4997 11.9798ZM12.4997 2.08398C10.5658 2.08398 8.71114 2.85221 7.34369 4.21966C5.97623 5.58712 5.20801 7.44178 5.20801 9.37565C5.20801 14.8444 12.4997 22.9173 12.4997 22.9173C12.4997 22.9173 19.7913 14.8444 19.7913 9.37565C19.7913 7.44178 19.0231 5.58712 17.6557 4.21966C16.2882 2.85221 14.4335 2.08398 12.4997 2.08398Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg146);
export default __webpack_public_path__ + "static/media/svg146.fe5a230d47430059bbeaca42d3f73323.svg";
export { ForwardRef as ReactComponent };